import React from 'react';
import { __ } from '@wordpress/i18n';

export default function PostControlButtons({ 
  onMoveUp, 
  onMoveDown, 
  canMoveUp = false, 
  canMoveDown = false,
  className = '' 
}) {
  return (
    <div className={`post-control-buttons ${className}`}>
      {onMoveUp && (
        <button
          className="components-button is-small"
          onClick={onMoveUp}
          disabled={!canMoveUp}
          aria-label={__('Move up', 'papa-lp')}
        >
          <svg
            viewBox="0 0 24 24"
            width="24"
            height="24"
            aria-hidden="true"
            focusable="false"
          >
            <path d="M10.6 6L9.4 7l4.6 5-4.6 5 1.2 1 5.4-6z"></path>
          </svg>
        </button>
      )}
      {onMoveDown && (
        <button
          className="components-button is-small"
          onClick={onMoveDown}
          disabled={!canMoveDown}
          aria-label={__('Move down', 'papa-lp')}
        >
          <svg
            viewBox="0 0 24 24"
            width="24"
            height="24"
            aria-hidden="true"
            focusable="false"
          >
            <path d="M14.6 7l-1.2-1L8 12l5.4 6 1.2-1-4.6-5z"></path>
          </svg>
        </button>
      )}
    </div>
  );
}

